import { IRectangle, List } from '@fluentui/react';
import { EmailModel } from '../../models/EmailModel';
import EmailItemView from './EmailItemView';

type EmailGridProps = {
    emails: EmailModel[];
    onEdit: (email: EmailModel) => void;
    onDelete: (email: EmailModel) => void;
}

export default function EmailGridView({ emails, onEdit, onDelete }: EmailGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return emails.length;
    }

    const onRenderCell = (email?: EmailModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const hPadding = columnCount === 1 ? " ph-10" : "";
        const vPadding = columnCount === 1 ? " pv-10" : " pv-20";

        if (email == null) return <>empty</>;

        return <div
            key={email.id + "-wrapper"}
            className={"list-grid-tile" + vPadding + hPadding}
            style={{ width: width, height: "auto" }}
            data-is-focusable={true}
        >
            <EmailItemView
                key={email.id}
                email={email}
                onEdit={onEdit}
                onDelete={onDelete}
            />
        </div>;
    }

    return <div className="ml--20 mr--20">
        <List
            items={emails}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}